import React, { useState } from 'react';
import moment, { Moment } from 'moment';
import { Row, Col, Form } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
import * as S from './styles';

const { useWatch } = Form;

interface DueDateDropdownProps {
	limitDate?: Moment;
	fieldName?: string;
	isRequired?: boolean;
}

export function DueDateDropdown({
	fieldName = '',
	isRequired = false,
	limitDate = undefined
}: Readonly<DueDateDropdownProps>): JSX.Element {
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const dueDate = useWatch(fieldName);

	function handleToggleDatePicker(): void {
		setIsOpen((prevState) => !prevState);
	}

	return (
		<Row>
			<Col>
				<S.IconButton $isSelected={!!dueDate} onClick={handleToggleDatePicker}>
					<CalendarOutlined />
				</S.IconButton>
			</Col>
			<Col>
				<S.CustomFormItem required={isRequired} name={fieldName}>
					<S.InvisibleDatePicker
						open={isOpen}
						placement="bottomRight"
						onOpenChange={handleToggleDatePicker}
						disabledDate={limitDate ? (current) => current > moment(limitDate) : undefined}
					/>
				</S.CustomFormItem>
			</Col>
		</Row>
	);
}
